export default "__VITE_ASSET__AMRtLmpD__"